import {
    CONTAINER_ZIPCODE,
    CONTAINER_CITY,
    CONTAINER_STREET,
    CONTAINER_HOUSE_NUMBER,
    CONTAINER_SUBMIT,
    CONTAINER_FORM,
    CONTAINER_RESULT,
    CONTAINER_NOTIFICATION_SUCCESS,
    CONTAINER_NOTIFICATION_SUCCESS_CABLE,
    CONTAINER_NOTIFICATION_FAILED,
    CONTAINER_NOTIFICATION_SERVICE_NOT_AVAILABLE,
    CONTAINER_AVAILABILITY_CHECK_FAILED,
    CONTAINER_AVAILABILITY_CHECK_SUCCEED,
    CONTAINER_AVAILABILITY_CHECK_CABLE_SUCCEED,
    CONTAINER_AVAILABILITY_SERVICE_NOT_AVAILABLE,
    CONTAINER_ADDRESS_FROM_FORM,
    CONTAINER_ADDRESS_FROM_SERVICE,
    CONTAINER_CABLE_ADDRESS_FROM_SERVICE,
    CONTAINER_DEFAULT_CONTENT,
    CONTAINER_DEFAULT_CONTENT_CABLE,
    CONTAINER_WILUE_CONTENT,
    CONTAINER_EWA_CONTENT,
    CONTAINER_USER_ROUTING,
} from '../../../constant';

import { formValidation } from '@vfde-brix/core';

import {
    mountInputFieldZipcode,
    mountInputFieldCity,
    mountInputFieldStreet,
    mountInputFieldHouseNumber,
} from '../../../components/InputField';
import { mountButton } from '../../../components/Button';
import {
    mountNotificationSuccess,
    mountNotificationFailed,
    mountNotificationServiceNotAvailable,
} from '../../../components/Notification';
import { mountLoadingSpinner } from '../../../components/LoadingSpinner';
import { encodeUserInput } from './encodeUserInput';
import {
    initRedirectButton,
    removeRedirectButton,
} from './renderButton';

/**
 * Interface for Adresses
 */
export interface IAddress {
    /**
     * street to be checked
     */
    street: string;
    /**
     * housenumber to be checked
     */
    housenumber: string;
    /**
     * zipcode to be checked
     */
    zip: string;
    /**
     * city to be checked
     */
    city: string;
}

/**
 * render address in an container
 * @param address
 * @param container
 */
export const renderAddressInContainer = (address: IAddress, container: HTMLElement) => {
    const streetEncoded = encodeUserInput(address.street);
    const cityEncoded = encodeUserInput(address.city);
    const zipEncoded = encodeUserInput(address.zip);
    const hnrEncoded = encodeUserInput(address.housenumber);

    container.innerHTML  = `${streetEncoded} ${hnrEncoded}<br>${zipEncoded} ${cityEncoded}`;
};

/**
 * toggleHideAndShow
 * @param element HTMLElement
 */
export const toggleHideAndShow = (element: HTMLElement) => {
    if ('none' === element.style.display) {
        element.style.display = 'block';
    } else {
        element.style.display = 'none';
    }
};
/**
 * display block container
 */
export const showContainer = (container: HTMLElement) => {
    container.style.display = 'block';
};

/**
 * display none container
 */
export const hideContainer = (container: HTMLElement) => {
    container.style.display = 'none';
};

/**
 * Export createInputFieldContainer
 *
 */
export const createInputFieldContainer = (containerId: string) => {
    const inputFieldContainer = document.getElementById(containerId);
    inputFieldContainer.innerHTML = '';

    return inputFieldContainer;
};

/**
 * Export createFormular
 *
 * @export createFormular
 */
export const createFormular = (action) => {
    /**
     * ZipCode
     */
    const zipCodeContainer = createInputFieldContainer(CONTAINER_ZIPCODE);
    const zipcodeInputField = mountInputFieldZipcode(zipCodeContainer, function (event: Event, value: string) {
        action.saveFormDataValues({
            zipcode: value,
        });
    });
    /**
     * City
     */
    const cityContainer = createInputFieldContainer(CONTAINER_CITY);
    const cityInputField = mountInputFieldCity(cityContainer, function (event: Event, value: string) {
        action.saveFormDataValues({
            city: value,
        });
    });
    /**
     * Street
     */
    const streetContainer = createInputFieldContainer(CONTAINER_STREET);
    const streetInputField = mountInputFieldStreet(streetContainer, function (event: Event, value: string) {
        action.saveFormDataValues({
            street: value,
        });
    });
    /**
     * HNR
     */
    const hnrContainer = createInputFieldContainer(CONTAINER_HOUSE_NUMBER);
    const hnrInputField = mountInputFieldHouseNumber(hnrContainer, function (event: Event, value: string) {
        action.saveFormDataValues({
            houseNumber: value,
        });
    });

    /**
     * BUTTON
     */
    const submitButtonContainer = createInputFieldContainer(CONTAINER_SUBMIT);
    const submitButtonText = (window as any).additionalPageOptions.submitButtonText;
    const submitButton = mountButton(submitButtonContainer, submitButtonText, function (event: Event, value: string) {
        action.getAddress();
    });

    /**
     * FormValidation
     */
    const formToValidate = {
        formFields: [
            zipcodeInputField,
            cityInputField,
            streetInputField,
            hnrInputField,
        ],
        submitButton: submitButton,
        fieldsWithErrors: [],
    };

    /**
     * bind form validation
     */
    formValidation(formToValidate);
};

/**
 * Export mountNotifications
 *
 * @export mountNotifications
 */
export const mountNotifications = () => {
    const containerNotificationSuccess = document.getElementById(CONTAINER_NOTIFICATION_SUCCESS);
    const containerNotificationSuccessCable = document.getElementById(CONTAINER_NOTIFICATION_SUCCESS_CABLE);
    const containerNotificationFailed = document.getElementById(CONTAINER_NOTIFICATION_FAILED);
    const containerNotificationServiceNotAvailable = document.getElementById(CONTAINER_NOTIFICATION_SERVICE_NOT_AVAILABLE);

    const textSuccessFiber = (window as any).additionalPageOptions.notifications.textSuccessFiber;
    const textSuccessCableFiber = (window as any).additionalPageOptions.notifications.textSuccessCableFiber;
    const textFail = (window as any).additionalPageOptions.notifications.textFail;

    mountNotificationSuccess(containerNotificationSuccess, textSuccessFiber);
    mountNotificationSuccess(containerNotificationSuccessCable, textSuccessCableFiber);
    mountNotificationFailed(containerNotificationFailed, textFail);
    mountNotificationServiceNotAvailable(containerNotificationServiceNotAvailable);
};

/**
 * Export serviceNotAvailable
 *
 * @export serviceNotAvailable
 */
export const serviceNotAvailable = () => {
    const containerServiceNotAvailable = document.getElementById(CONTAINER_AVAILABILITY_SERVICE_NOT_AVAILABLE);
    showContainer(containerServiceNotAvailable);
    showResult();
};

/**
 * Export addressNotInExpansionArea
 *
 * @export addressNotInExpansionArea
 */
export const addressNotInExpansionArea = (adress: IAddress) => {
    const containerAvailabiltyCheckFailed = document.getElementById(CONTAINER_AVAILABILITY_CHECK_FAILED) as HTMLElement;
    const containerAddressFromForm = document.getElementById(CONTAINER_ADDRESS_FROM_FORM) as HTMLElement;
    renderAddressInContainer (adress, containerAddressFromForm);
    showContainer(containerAvailabiltyCheckFailed);
    showResult();
};

/**
 * Export addressIsInExpansionArea
 *
 * @export addressIsInExpansionArea
 */
export const addressIsInExpansionArea = (adress: IAddress, adressArt: string, technologie: string) => {
    const containerAddressFromService = document.getElementById(CONTAINER_ADDRESS_FROM_SERVICE) as HTMLElement;
    const containerCableAddressFromService = document.getElementById(CONTAINER_CABLE_ADDRESS_FROM_SERVICE) as HTMLElement;
    const containerDefaultContent = document.getElementById(CONTAINER_DEFAULT_CONTENT) as HTMLElement;
    const containerDefaultContentCabel = document.getElementById(CONTAINER_DEFAULT_CONTENT_CABLE) as HTMLElement;
    const containerEWAContent = document.getElementById(CONTAINER_EWA_CONTENT) as HTMLElement;
    const containerWilueContent = document.getElementById(CONTAINER_WILUE_CONTENT) as HTMLElement;
    const containerAvailabiltyCheckSucceed = document.getElementById(CONTAINER_AVAILABILITY_CHECK_SUCCEED) as HTMLElement;
    const containerAvailabiltyCheckCableSucceed = document.getElementById(CONTAINER_AVAILABILITY_CHECK_CABLE_SUCCEED) as HTMLElement;
    const containerUserRouting = document.getElementById(CONTAINER_USER_ROUTING) as HTMLElement;

    // EWA or Wilü? - only first 3 chars because to avoid trouble with umlaut
    adressArt = adressArt.toUpperCase().slice(0, 3);

    if ('Glasfaser' === technologie || '' === technologie) {
        /* Glasfaser -> Addressart */
        if ('EWA' === adressArt) {
            showContainer(containerEWAContent);
        } else if ('WIL' === adressArt) {
            showContainer(containerWilueContent);
        } else {
            showContainer(containerDefaultContent);
        }
        renderAddressInContainer (adress, containerAddressFromService);
        showContainer(containerAvailabiltyCheckSucceed);
    } else {
        /* Kabel */
        showContainer(containerDefaultContentCabel);
        renderAddressInContainer (adress, containerCableAddressFromService);
        showContainer(containerAvailabiltyCheckCableSucceed);
    }

    showResult();
};

/**
 * Export showResult
 *
 * @export showResult
 */
export const showResult = () => {
    const containerForm = document.getElementById(CONTAINER_FORM) as HTMLElement;
    const containerResult = document.getElementById(CONTAINER_RESULT) as HTMLElement;
    showContainer(containerResult);
    hideContainer(containerForm);
};

/**
 * Export initialView
 *
 * @export initialView
 */
export const initialView = () => {
    const containerForm = document.getElementById(CONTAINER_FORM) as HTMLElement;
    const containerResult = document.getElementById(CONTAINER_RESULT) as HTMLElement;
    const containerAvailabiltyCheckFailed = document.getElementById(CONTAINER_AVAILABILITY_CHECK_FAILED) as HTMLElement;
    const containerDefaultContent = document.getElementById(CONTAINER_DEFAULT_CONTENT) as HTMLElement;
    const containerEWAContent = document.getElementById(CONTAINER_EWA_CONTENT) as HTMLElement;
    const containerWilueContent = document.getElementById(CONTAINER_WILUE_CONTENT) as HTMLElement;
    const containerAvailabiltyCheckSucceed = document.getElementById(CONTAINER_AVAILABILITY_CHECK_SUCCEED) as HTMLElement;
    const containerAvailabiltyCheckCableSucceed = document.getElementById(CONTAINER_AVAILABILITY_CHECK_CABLE_SUCCEED) as HTMLElement;
    const containerAvailabiltyCheckServiceNotAvailable = document.getElementById(CONTAINER_AVAILABILITY_SERVICE_NOT_AVAILABLE) as HTMLElement;
    showContainer(containerForm);
    hideContainer(containerResult);
    hideContainer(containerAvailabiltyCheckFailed);
    hideContainer(containerAvailabiltyCheckSucceed);
    hideContainer(containerAvailabiltyCheckCableSucceed);
    hideContainer(containerDefaultContent);
    hideContainer(containerEWAContent);
    hideContainer(containerWilueContent);
    hideContainer(containerAvailabiltyCheckServiceNotAvailable);
};

/**
 * Export updateGlasfaserVfpFormular
 *
 * @export updateGlasfaserVfpFormular
 */
export const updateGlasfaserVfpFormular = (newState) => {
    let address: IAddress; // receiving address from Service (normalized address)
    let addressForm: IAddress; // using address from form

    const loadingContainer = mountLoadingSpinner();

    if (newState.loading) {
        loadingContainer.show();
    } else {
        loadingContainer.hide();
    }

    if (newState.error) {
        serviceNotAvailable();

        return;
    }

    /* show form */
    if (newState.initAddressForm) {
        initialView();

        return;
    }

    // address not in expansion area
    if (newState.addressNotFound) {
        addressForm = {
            street: newState.formData.street,
            housenumber: newState.formData.houseNumber,
            zip: newState.formData.zipcode,
            city: newState.formData.city,
        };
        addressNotInExpansionArea (addressForm);
        removeRedirectButton();
    } else {
        address = {
            street: newState.responseData.REF_STR,
            housenumber: newState.responseData.REF_HNR,
            zip: newState.responseData.REF_PLZ,
            city: newState.responseData.REF_ORT,
        };
        addressIsInExpansionArea (
            address,
            newState.responseData.ADRESSART,
            newState.responseData.TECHNOLOGIE,
        );
        initRedirectButton(newState.responseData.URL, newState.responseData.URLCONTRACTLP);
    }
};
